// extracted by mini-css-extract-plugin
export default {"table":"KoseckiSummary_table__MUCRH","value":"KoseckiSummary_value__Upuhc","underline":"KoseckiSummary_underline__z8VnG"};